import { render, staticRenderFns } from "./limit_reached_modal.vue?vue&type=template&id=47d73c64&scoped=true&"
import script from "./limit_reached_modal.vue?vue&type=script&lang=js&"
export * from "./limit_reached_modal.vue?vue&type=script&lang=js&"
import style0 from "./limit_reached_modal.vue?vue&type=style&index=0&id=47d73c64&lang=scss&scoped=true&"
import style1 from "./limit_reached_modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d73c64",
  null
  
)

export default component.exports